export const TOS_PDF_URL = 'https://www.sangoma.com/wp-content/uploads/Sangoma-Meet-ToS.pdf';
